// extracted by mini-css-extract-plugin
export default {"error":"TextArea_error__L0rrT","textError":"TextArea_textError__ueZjC"};